
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';

const initialState = {
    currentMenuKey: "1"
};

export const AdminPageSlice = createSlice({
    name: 'AdminPage',
    initialState,
    reducers: {
        setCurrentMenuKey: (state,action) => {
            console.log(999999999999999)
            console.log(state.currentMenuKey);
            state.currentMenuKey = action.payload;
        }
    },
});

export const selectCurrentMenuKey = (state) => state.AdminPage.currentMenuKey;
export const {
    setCurrentMenuKey
} = AdminPageSlice.actions;

export default AdminPageSlice.reducer;
